import { createSlice } from "@reduxjs/toolkit";

export const configdata = createSlice({
    name: 'configdata',

    initialState: {
        selectedTreeItem: "",
        organizationdatatree: {},
        userslist: [],
        configtreepathselected: ['General'],
        selectedconfigtabpath: [],
        templateName: '',
        templateGroup: '',
        editwidgetselect: '',
        editbasicprops: '',
        editextendedprops: '',
        editcreatewidget: 'Add',
        editwidgetlistjson: '',
        selectedTab: { tab: "general", value: 0 },
        templateState: { state: 0, id: "", name: "" },
        selectedTreeNode: '',
        overviewbarCollection:[],
        overviewbarConfigCollection:[],
        editwidgetid: null, 
        editwidgetmode: "New", 
    },

    reducers: {
        setSelectedTreeItem: (state, treeItem) => {
            state.selectedTreeItem = treeItem.payload
        },
        setSelectedTreeNode : (state, selectedTreeNode) => {
            state.selectedTreeNode = selectedTreeNode.payload
        },
        setOrganizationtree: (state, orgtree) => {
            state.organizationdatatree = orgtree.payload
        },
        updateuserslist: (state, users) => {
            state.userslist = users.payload
        },
        updateconfigtreepathselected: (state, configtreepath) => {
            state.configtreepathselected = configtreepath.payload
        },
        updateconfigtabpath: (state, configtabpath) => {
            state.selectedconfigtabpath = configtabpath.payload
        },
        setTemplateName: (state, name) => {
            state.templateName = name.payload
        },
        setTemplateGroup: (state, templateGroup) => {
            state.templateGroup = templateGroup.payload
        },
        updateeditwidgetdetails: (state, name) => {
            //console.log("payload ", basicprops, extendedprops)
            state.editwidgetselect = name.payload
            //state.editbasicprops = basicprops.payload
            //state.editextendedprops = extendedprops.payload
        },
        updateselectedbasicprops: (state, basicprops) => {
            state.editbasicprops = basicprops.payload
        },
        updateselectedextendedprops: (state, extendedprops) => {
            state.editextendedprops = extendedprops.payload
        },
        updateeditcreatewidget: (state, type) => {
            state.editcreatewidget = type.payload
        },
        updateupdateeditwidgetjson: (state, widgetlistjson) => {
            state.editwidgetlistjson = widgetlistjson.payload
        },
        setSelectedTab: (state, treeItem) => {
          state.selectedTab = treeItem.payload;
        },
        setTemplateState: (state, treeItem) => {
          state.templateState = treeItem.payload;
        },
          resetWidgetCreation: (state) => {
            state.editwidgetselect = '';
            state.editbasicprops = '';
            state.editextendedprops = '';
            state.editcreatewidget = 'Add';
            state.editwidgetlistjson = '';
        },
        setEditWidgetId: (state, action) => { // <-- Added setEditWidgetId reducer
            state.editwidgetid = action.payload;
        },
        setEditWidgetMode: (state, action) => { // <-- Added setEditWidgetMode reducer
            state.editwidgetmode = action.payload;
        },
        updateoverviewbarCollection: (state, overviewbarCollection) => {
            state.overviewbarCollection = overviewbarCollection.payload;
        },
        updateoverviewbarConfigCollection: (state, overviewbarConfigCollection) => {
            state.overviewbarConfigCollection = overviewbarConfigCollection.payload;
        }
    }
})

export const { 
    setSelectedTreeItem, 
    setOrganizationtree, 
    updateuserslist, 
    updateconfigtreepathselected, 
    updateconfigtabpath, 
    setTemplateName, 
    setTemplateGroup,
    updateeditwidgetdetails,
    updateselectedbasicprops,
    updateselectedextendedprops,
    setSelectedTab,
    setTemplateState,
    setSelectedTreeNode,
    resetWidgetCreation,
    setEditWidgetId, 
    setEditWidgetMode ,
    updateoverviewbarCollection,
    updateoverviewbarConfigCollection
 } = configdata.actions

export default configdata.reducer